import { useCallback } from 'react';
import { useApi } from './useApi.ts';
import { useNotifications } from '../context/NotificationContext.tsx';

const DISCORD_URL = 'https://discord.gg/MuCFu8wnfv';

/** Opens the Discord link and best-effort grants the join_discord achievement. */
export function useDiscordJoin() {
  const { notifyDiscordJoin } = useApi();
  const { pushAchievementToasts } = useNotifications();

  return useCallback(() => {
    window.open(DISCORD_URL, '_blank', 'noopener,noreferrer');
    notifyDiscordJoin()
      .then(({ unlockedAchievements }) => {
        if (unlockedAchievements.length) pushAchievementToasts(unlockedAchievements);
      })
      .catch(() => {});
  }, [notifyDiscordJoin, pushAchievementToasts]);
}
